/**
 * Lightweight hook for marking focusable elements with data attributes.
 * Uses imperative DOM manipulation for zero re-render overhead.
 *
 * @param focusId - Unique identifier for the focusable element (e.g., "quiz-0-question")
 * @returns Ref to attach to the focusable element
 *
 * @example
 * ```tsx
 * const questionRef = useFocusTarget(`quiz-${index}-question`);
 * return <input ref={questionRef} />;
 * ```
 */
export const useFocusTarget = <T extends HTMLElement = HTMLElement>(
  focusId: string,
) => {
  return (node: T) => {
    if (node) {
      node.setAttribute('data-focus-id', focusId);
    }
  };
};
